import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-235">
      <div className="absolute inset-0 bg-radial-stars opacity-50" data-id="element-236"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-237">
        <FadeIn data-id="element-238">
          <div className="text-center mb-12" data-id="element-239">
            <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-240">
              Recupera tus noches y tu vitalidad hoy mismo.
            </h2>
            <p className="text-xl text-cream-muted" data-id="element-241">
              El acceso completo al Protocolo de Sueño Profundo 50+ y la Audio
              Guía de Inducción tiene un valor único.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-242">
          <div className="bg-navy-800 border-2 border-gold-500/40 rounded-sm p-8 md:p-12 text-center box-glow max-w-2xl mx-auto" data-id="element-243">
            <div className="flex justify-center gap-1 mb-6" data-id="element-244">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-245" />)}
            </div>

            <p className="text-lg text-cream-muted mb-4 uppercase tracking-wider font-medium" data-id="element-246">
              Precio Total
            </p>
            <div className="text-6xl md:text-7xl font-serif text-cream mb-8 flex justify-center items-start" data-id="element-247">
              <span className="text-3xl mt-2 mr-1 text-gold-400" data-id="element-248">$</span>
              27
              <span className="text-xl mt-8 ml-2 text-cream-muted font-sans" data-id="element-249">
                USD
              </span>
            </div>

            <Button href="#checkout" className="w-full md:w-auto px-12 py-5 text-xl mb-6 animate-[pulse_3s_ease-in-out_infinite]" data-id="element-250">
              Descargar el Protocolo Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-cream-muted" data-id="element-251">
              <ShieldCheckIcon className="w-4 h-4 text-gold-500" data-id="element-252" />
              <span data-id="element-253">
                Acceso instantáneo después de tu compra, incluso si son las 3
                AM.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}